import { getPaymentZoneBackgroundColor, getPaymentZoneColor } from "@/helper/colors/payment-zones";
import { CustomBadge } from "@/components/ui/custom-badge";

export const ZoneNameBadge = ({ zoneName, className }: { zoneName: string; className?: string }) => {
  const backgroundColor = getPaymentZoneBackgroundColor(zoneName);
  const textColor = getPaymentZoneColor(zoneName);
  return <CustomBadge text={zoneName} backgroundColor={backgroundColor} textColor={textColor} className={className} />;
};
